var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0612 2.1129C10.8045 1.87869 10.4998 1.6929 10.1643 1.56615C9.82889 1.43939 9.46935 1.37415 9.10626 1.37415C8.74317 1.37415 8.38363 1.43939 8.0482 1.56615C7.71276 1.6929 7.40799 1.87869 7.15131 2.1129L6.6186 2.59873L6.08588 2.1129C5.5674 1.64004 4.86418 1.37439 4.13093 1.37439C3.39768 1.37439 2.69446 1.64004 2.17598 2.1129C1.65749 2.58576 1.36621 3.22709 1.36621 3.89582C1.36621 4.56454 1.65749 5.20587 2.17598 5.67873L2.70869 6.16457L6.6186 9.7304L10.5285 6.16457L11.0612 5.67873C11.318 5.44464 11.5217 5.16669 11.6607 4.86077C11.7997 4.55485 11.8712 4.22696 11.8712 3.89582C11.8712 3.56468 11.7997 3.23678 11.6607 2.93086C11.5217 2.62494 11.318 2.347 11.0612 2.1129V2.1129Z",
    fill: "#0FAFE9",
    stroke: "#0FAFE9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.0614,
    height: 11,
    fill: "white",
    transform: "translate(0.587891)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFull);
export default __webpack_public_path__ + "static/media/heart_full.645b45f9f6ade46edd8ca2f4156d9fae.svg";
export { ForwardRef as ReactComponent };